import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'

const options = { ns: getUserLanguage() }

function getValidators() {
  return {
    required: message => val => !!val || message,
    containsLettersAndDigits: message => val => (/[A-z]/.test(val) && /\d/.test(val)) || message,
    minLength: length => val => val.length >= length || i18next.t('Должно быть не меньше {length} символов', { ...options, length }),
    maxLength: length => val => val.length <= length || i18next.t('Должно быть не больше {length} символов', { ...options, length }),
  }
}

export default getValidators
